import React, { useState } from "react";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import { motion } from "framer-motion";

import { AppWrap, MotionWrap } from "../../wrapper";
import { LoadingSpinner } from "../../components";
import { urlFor } from "../../client";
import { useData } from "../../contexts/DataContext";
import "./Work.scss";

const Work = () => {
  const { works: rawWorks, loading, error } = useData();
  const [filterWork, setFilterWork] = useState([]);
  const [activeFilter, setActiveFilter] = useState("All");
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  // Initialize works and filterWork when data loads
  React.useEffect(() => {
    if (rawWorks.length > 0) {
      setFilterWork(rawWorks);
    }
  }, [rawWorks]);

  if (loading) {
    return <LoadingSpinner message="Loading projects..." />;
  }

  if (error) {
    return <div className="error-message">Error loading data: {error}</div>;
  }

  const works = rawWorks;

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === "All") {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };

  return (
    <div className="app__works">
      <h2 className="head-text">
        My Creative <span>Portfolio</span> Section
      </h2>

      <div className="app__work-filter">
        {["AI", "Web App", "Mobile App", "All"].map((item, index) => (
          <div
            key={index}
            onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item ${
              activeFilter === item ? "item-active" : ""
            }`}
          >
            {item}
          </div>
        ))}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map((work, index) => (
          <div className="app__work-card" key={index}>
            <div className="app__work-image">
              {work.imgUrl && (
                <img src={urlFor(work.imgUrl)} alt={work.name} />
              )}
              <div className="app__work-tag">{work?.tags[0] || ""}</div>
            </div>

            <div className="app__work-content">
              <h3>{work.title}</h3>
              <p>{work?.description || ""}</p>
              
              <div className="app__work-buttons">
                {work.projectLink && (
                  <a 
                    href={work.projectLink} 
                    target="_blank" 
                    rel="noreferrer"
                  >
                    <AiFillEye />
                    Demo
                  </a>
                )}
                {work.codeLink && (
                  <a 
                    href={work.codeLink} 
                    target="_blank" 
                    rel="noreferrer"
                  >
                    <AiFillGithub />
                    Code
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default AppWrap(MotionWrap(Work, "app__works"), "work",  "app__primarybg");
